// extracted by mini-css-extract-plugin
module.exports = {"container":"PeopleRow_container__1ypjP","select":"PeopleRow_select__11Nih","field":"PeopleRow_field__3jc7l","fadeIn":"PeopleRow_fadeIn__3FJeZ","fadeIn2":"PeopleRow_fadeIn2__xaKCf"};